export const transmissions = [
  { label: "Automatic", apiValue: true },
  { label: "Manual", apiValue: false },
];

export const cdlTypes = [{ label: "Class A" }, { label: "Class B" }];

export const workTypes = [
  { label: "Local", value: "local" },
  { label: "OTR (Over-the-Road)", value: "otr" },
  { label: "Regional", value: "regional" },
  { label: "I don't care", value: "idc" },
];

export const referralSourcesOptions = [

    {
      "label": "My CDL School sent me",
      "value": 1,
    },
    {
      "label": "Facebook Ads",
      "value": 2,
    },
    {
      "label": "Google Ads",
      "value": 3,
    },
    {
      "label": "Heard about it from a friend",
      "value": 4,
    },
    {
      "label": "I found ELDT.com online searching",
      "value": 5,
    },
    {
      "label": "My Employer sent me",
      "value": 6,
    }

];
